<!--
================================================
Un composant permettant de filter la report view par tr facturable

Url d'accès : http://localhost:8080/fr/cronocloud-inc/reports/summary

LIMITATION DU COMPOSANT :

================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <div id="BillableFilterComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}"  v-click-outside="onClickOutside">
        <div class="selector" >
            <div class="count" v-show="filterCount >= 1">{{filterCount}}</div>

            <div class="opener" v-on:click="toggleList()" v-bind:title="$t('filtrerParFacturable')">
                <span><font-awesome-icon class="icon iconType is-pulled-left" :icon="['fas', 'dollar-sign']"/></span>
                <span class="text ">{{$t('facturable')}}</span>

                <span><font-awesome-icon class="icon is-pulled-right chevron " :icon="['fas', 'chevron-down']"/></span>
            </div>

            <div class="list" v-show="listVisibility">
                <ul>

                    <div class="filterContent">

                        <li v-bind:class="'billableBillable'">
                            <label class="checkbox" v-on:change="updateCount(), emitFilterState()">
                                <input type="checkbox" v-bind:class="'cbox_Billable'" v-model="billableFilter">
                                {{$t('facturable')}}
                            </label>
                        </li>

                        <li v-bind:class="'billableNonBillable'">
                            <label class="checkbox" v-on:change="updateCount(), emitFilterState()">
                                <input type="checkbox" v-bind:class="'cbox_nonBillable'" v-model="nonBillableFilter">
                                {{$t('nonfacturable')}}
                            </label>
                        </li>

                    </div>

                </ul>
            </div>

        </div>

    </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SpinnerLoaderComp from "../SpinnerLoaderComp";
    import SentryMixin from "../../mixins/SentryMixin";
    import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin";
    import InterceptorMixin from "../../mixins/InterceptorMixin";
    import vClickOutside from 'v-click-outside'

    export default {
        name: 'BillableFilterComp',
        components: {SpinnerLoaderComp},
        directives: {
          clickOutside: vClickOutside.directive,
        },
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin],
        data: function () {
            return {

                defaultValue: 'all', // string, par défaut le filtre affiche les tr facturables et non facturables)
                listVisibility: false, // bool la visibilité de la liste
                billableFilter: false, // bool indique s'il faut inclure les tr facturables dans le rapport
                nonBillableFilter: false, // bool indique s'il faut inclure les tr non-facturables dans le rapport
                filterCount: 0, //int le nombre d'éléments à filter,
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                user: state => state.user,
                themeToDisplay: state => state.app.themeToDisplay

            }),
            //----------------------------------------------
            // other computed props :

            /* la valeur globale du filtre résumé en un mot (all/billable/nonBillable/null)
             Sert à mettre à jour le param 'billable' dans l'url
             */
            golbalFilterValue: {
                get: function () {
                    if(this.billableFilter && this.nonBillableFilter){
                        return 'all'
                    }
                    else if(this.billableFilter && this.nonBillableFilter == false){
                        return 'billable'
                    }
                    else if(this.billableFilter==false && this.nonBillableFilter == true){
                        return 'nonB'
                    }
                    else if(this.billableFilter==false && this.nonBillableFilter == false){
                        return null
                    }
                },
                set: function (newValue) {this.golbalFilterValue = newValue}
            }
        },
        watch: {

            // maj du param d'url 'billable' quand golbalFilterValue change
            golbalFilterValue: function () {
                this.$router.push({ query: { ...this.$route.query, billable: this.golbalFilterValue}});
            },

            // quand billableFilter est mis à jour on émet un event
            billableFilter:function () {
                this.emitFilterState()
            },

            // quand nonBillableFilter est mis à jour on émet un event
            nonBillableFilter:function () {
                this.emitFilterState()
            },

        },

        methods: {


          /* Masque le filtre lorsque l'on clique en dehors*/
          onClickOutside (event) {
            this.hideList()
          },

            /*
                  Envoie l'état du filtre via dans un event.
                  (Avec les valeurs de this.billableFilter & this.nonBillableFilter)
                  Sert à updater les critères de tri dans ReportsView
               */
            emitFilterState() {
                this.$store.commit('UpdateReportsViewFilterRulesBillable', {
                    billableFilter: this.billableFilter,
                    nonBillableFilter: this.nonBillableFilter
                })
            },


            toggleList() {
                if (this.listVisibility == true) {
                    this.hideList()
                } else {
                    this.showList()
                }
            },

            showList(){
                this.listVisibility = true;
            },
            hideList(){
                this.listVisibility = false;
            },


            /**
             * Calcul le nombre total d'éléments cochés dans le filtre.
             */
            updateCount() {
                let total = 0;
                if (this.billableFilter) {
                    total++
                }
                if (this.nonBillableFilter) {
                    total++
                }
                this.filterCount = total
                this.$root.$emit('filter_billable_count_update',total)
            }

            /*
             * Sélectionne tous les éléments dans la liste
             */
            ,selectAll(){
                this.billableFilter = true
                this.nonBillableFilter = true
            }

            /*
             * Désélectionne tous les éléments dans la liste
             */
            ,unSelectAll(){
                this.billableFilter = false
                this.nonBillableFilter = false
            }

            /**
             * Réinitialise le composant à sa valeur d'origine (désactive tous les filtres)
             */
            ,resetFilter(){
                this.filterCount= 0;
                this.unSelectAll();

                // vidage dans le store (pour reset de la report view)
                this.$store.commit('UpdateReportsViewFilterRulesBillable', {
                    billableFilter: false,
                    nonBillableFilter: false
                })

                this.$router.push({ query: { ...this.$route.query, billable: null}});

            }


            /*
             Configure le filtre en fonction des paramètres d'url
             */
            , initConfigFromUrl() {

                // si billable est fournit dans l'url on l'utilise pour configurer le filtre
                if (this.$route.query.billable != null) {

                    switch (this.$route.query.billable) {
                        case  'all': this.selectAll() ; break;
                        case  'billable':this.billableFilter=true ; break;
                        case  'nonB':this.nonBillableFilter=true ; break;
                    }
                }
                this.updateCount()

            }

        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {


            // écoute de l'évent 'reinit_filters' emit depuis FiltersComp
            this.$root.$on('reinit_filters', () => {
                this.resetFilter()
            })


            // Note : j'ai dû décaler le déclenchement de 'initConfigFromUrl', sinon, l'event 'filter_billable_count_update' dans updateCount() déclenché depuis initConfigFromUrl() ne se déclenchait pas, j'ai choisi arbitrairement l'event "report_view_tr_loaded" indiquant le chargement des timerecords
            this.$root.$on('report_view_tr_loaded', () => {
                this.initConfigFromUrl()
            })

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../assets/css/globalVar.scss";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/


        #BillableFilterComp{

          // les styles appliqués ici sont ceux spécifique à ce filtre (sinon les styles communs sont dans FiltersComp)

          .filterContent {
            min-width: 10rem !important;
          }

          //////////////////////////////////////
          // DARK UI ///////////////////////////
          &.darkMode {

          }
        }
</style>
